<template>
  <v-chip
    v-bind="$attrs"
    :text-color="textColor"
    :class="`tag-status--${status} ${dark ? 'dark' : ''}`"
    class="tag-status"
    label
    v-on="$listeners"
  >
    <v-icon
      v-if="icon"
      :color="textColor"
      size="16"
      class="mr-2"
    >
      {{ icon }}
    </v-icon>
    <span v-if="text" class="v-chip__content">{{ text }}</span>
    <slot v-if="!text" />
  </v-chip>
</template>

<script>
const status = {
  INFO     : 'info',
  ERROR    : 'error',
  RATED    : 'rated',
  PENDING  : 'pending',
  SUCCESS  : 'success',
  WARNING  : 'warning',
  INACTIVE : 'inactive',
  AI       : 'ai'
};

export default {
  name  : 'TagStatus',
  props : {
    status: {
      type      : String,
      required  : true,
      default   : 'success',
      validator : (value) => Object.values(status).includes(value)
    },
    text: {
      type    : String,
      default : ''
    },
    icon: {
      type    : String,
      default : ''
    },
    dark: {
      type    : Boolean,
      default : false
    }
  },
  computed: {
    textColor() {
      const textColors = {
        [status.INFO]     : 'var(--tag-status-info-text-color, var(--v-info-base))',
        [status.ERROR]    : 'var(--tag-status-error-text-color, #7A000F)',
        [status.RATED]    : 'var(--tag-status-rated-text-color, #9C27B0)',
        [status.PENDING]  : 'var(--tag-status-pending-text-color, var(--v-neutrals-700-base))',
        [status.WARNING]  : 'var(--tag-status-warning-text-color, #BD5100)',
        [status.INACTIVE] : 'var(--tag-status-inactive-text-color, #607D8B)',
        [status.SUCCESS]  : 'var(--tag-status-success-text-color, var(--v-success-base))',
        [status.AI]       : 'var(--tag-status-ai-text-color, var(--v-ai-base))'
      };
      const textcolorDark = {
        [status.ERROR]   : 'var(--tag-status-error-text-color-dark, var(--v-error-base))',
        [status.WARNING] : 'var(--tag-status-warning-text-color-dark, var(--v-warning-base))'
      };

      return this.dark ? textcolorDark[this.status] || textColors[this.status] : textColors[this.status];
    }
  }
};
</script>

<style lang="scss" scoped>
span.tag-status {
  ::v-deep span.v-chip__content {
    color: inherit;
    font-weight: 700;
  }

  &.tag-status--success {
    border: 1px solid var(--tag-status-success-border-color, var(--v-success-lighten2));
    background-color: var(--tag-status-success-bg-color, var(--v-success-lighten5));

    &.dark {
      background-color: var(--tag-status-success-bg-color-dark, #1E232A) !important;
    }
  }

  &.tag-status--error {
    border: 1px solid var(--tag-status-error-border-color, var(--v-error-lighten5));
    background-color: var(--tag-status-error-bg-color, var(--v-error-lighten5));

    &.dark {
      border: 1px solid var(--tag-status-error-border-color-dark, var(--v-error-base));
      background-color: var(--tag-status-error-bg-color-dark, #251E25) !important;
    }
  }

  &.tag-status--warning {
    border: 1px solid var(--tag-status-warning-border-color, var(--v-warning-lighten5));
    background-color: var(--tag-status-warning-bg-color, var(--v-warning-lighten5));

    &.dark {
      border: 1px solid var(--tag-status-warning-border-color-dark, var(--v-warning-base));
      background-color: var(--tag-status-warning-bg-color-dark, #242225) !important;
    }
  }

  &.tag-status--info {
    border: 1px solid var(--tag-status-info-border-color, var(--v-info-lighten3));
    background-color: var(--tag-status-info-bg-color, var(--v-info-lighten5)) !important;
  }

  &.tag-status--rated {
    border: 1px solid var(--tag-status-rated-border-color, #BA68C8);
    background-color: var(--tag-status-rated-bg-color, #F3E5F5);
  }

  &.tag-status--pending {
    border: 1px solid var(--tag-status-pending-border-color, #ECEFF1);
    background-color: var(--tag-status-pending-bg-color, #ECEFF1);
  }

  &.tag-status--inactive {
    border: 1px solid var(--tag-status-inactive-border-color, #CFD8DC);
    background-color: var(--tag-status-inactive-bg-color, #ECEFF1);
  }

  &.tag-status--ai {
    border: 1px solid var(--tag-status-ai-border-color, var(--v-ai-lighten5));
    background-color: var(--tag-status-ai-bg-color, var(--v-ai-lighten5));
  }
}
</style>
